import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const Person2StateTrueNotiFalseIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "Person2StateTrueNotiFalseIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M11.5 12.5927C8.85956 12.5927 6.71095 10.4408 6.71095 7.79682C6.71095 5.15188 8.85956 3 11.5 3C14.1405 3 16.2886 5.15188 16.2886 7.79682C16.2886 10.4408 14.1405 12.5927 11.5 12.5927Z"
        fill="url(#paint0_linear_23_9513)"
      />
      <path
        d="M15.7987 14.0786H7.20086C4.8848 14.0786 3 15.9658 3 18.2858V20.8256C3 21.4744 3.52522 22 4.17258 22H18.851V21.9952C19.4868 21.9818 20 21.4661 20 20.8256V18.2858C20 15.9658 18.1152 14.0786 15.7987 14.0786Z"
        fill="url(#paint1_linear_23_9513)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_23_9513"
          x1="3"
          y1="14.2554"
          x2="20"
          y2="14.2554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_23_9513"
          x1="3"
          y1="14.2554"
          x2="20"
          y2="14.2554"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Person2StateTrueNotiFalseIcon;
